const StaffManagementConst = {
    basePath: "/staff-management",
    attendanceGroupBy: {
        DATE: "date",
        SUBCONTRACTOR: "subcontractor",
    },
};

export default StaffManagementConst;
